import { ErrorBoundary } from 'react-error-boundary';
import { AppError } from '../../pages/app-error';

export function AppErrorBoundary({ children }: React.PropsWithChildren) {
    return (
        <ErrorBoundary FallbackComponent={AppError}>
            {children}
        </ErrorBoundary>
    );
}
